import Typography from "components/typography";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PlatformItem from "./platformItem";
import PrimaryButton from "components/buttons/primary-button";
import Modal from "components/modal";
import AddLinkModal from "../modals/addLinkModal";
import { GetActiveArtist } from "services/user/getUser";

import api from "services/axiosInstance";
import Toast from "components/toast";
import { UpdateArtistData } from "services/user/setUser";

const ArtistMusicPlatforms = () => {
  const EmptyData = {
    spotify: "",
    appleMusic: "",
    audiomack: "",
    amazonMusic: "",
    deezer: "",
    tidal: "",
    youtube: ""
  };

  const HandleLinkChange = (value: string, platform: string) => {
    setLinks((prev) => ({ ...prev, [platform]: value }));
  };

  const Artist = GetActiveArtist();
  const [saving, setSaving] = useState(false);

  const [Links, setLinks] = useState(Artist?.musicPlatforms || EmptyData);

  const canSave = useMemo(() => {
    return Object.values(Links).every((link) => link !== "") && Artist?.id;
  }, [Links, Artist?.id]);

  const OnSaveChanges = async () => {
    try {
      setSaving(true);
      const { data } = await api.patch(`/artists/${Artist?.id}`, {
        musicPlatforms: Links
      });

      UpdateArtistData(data.data);
      Toast({
        type: "success",
        message: "Artist profile has been updated successfully"
      });
    } catch (error) {
      Toast({
        type: "error",
        message: "Something went wrong"
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>
      <Header>
        <Typography weight="medium" size="2xl">
          Artist Music Platforms
        </Typography>
      </Header>
      <Items>
        <PlatformItem
          platform={"Spotify"}
          link={Links.spotify}
          setLink={(link) => HandleLinkChange(link, "spotify")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="Apple Music"
          link={Links.appleMusic}
          setLink={(link) => HandleLinkChange(link, "appleMusic")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="Audiomack"
          link={Links.audiomack}
          setLink={(link) => HandleLinkChange(link, "audiomack")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="Amazon Music"
          link={Links.amazonMusic}
          setLink={(link) => HandleLinkChange(link, "amazonMusic")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="Deezer"
          link={Links.deezer}
          setLink={(link) => HandleLinkChange(link, "deezer")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="Tidal"
          link={Links.tidal}
          setLink={(link) => HandleLinkChange(link, "tidal")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="YouTube"
          link={Links.youtube}
          setLink={(link) => HandleLinkChange(link, "youtube")}
          disabled={Artist?.id ? false : true}
        />
      </Items>
      <SaveButton>
        <PrimaryButton
          text="Save Changes"
          loading={saving}
          onClick={OnSaveChanges}
          disabled={!canSave}
        />
      </SaveButton>
    </Container>
  );
};

export default ArtistMusicPlatforms;

const Container = styled.div`
  width: 100%;
  background-color: rgba(30, 30, 30, 0.5);
  border-radius: 0.8rem;
  /* backdrop-filter: blur(5px); */
  padding: 2.4rem;
`;

const Header = styled.div`
  padding-bottom: 1.6rem;
  width: 100%;
  border-bottom: 0.5px solid ${Colors.grey600};
  margin-bottom: 1.6rem;
`;

const Items = styled.div`
  border: 0.5px solid ${Colors.grey600};
  border-top: none;
  border-radius: 0.6rem;
  :first-child {
    border-radius: 0.6rem;
  }
`;

const SaveButton = styled.div`
  width: fit-content;
  margin-top: 2.4rem;
  margin-left: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
